import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { useSeo } from "../hooks/useSeo";
import { PageHero } from "../components/ui/PageHero";
import { CtaLink } from "../components/ui/CtaLink";
import { CtaBand } from "../components/ui/CtaBand";
import { DemoViewer } from "../components/demo/DemoViewer";
export function Demo() {
  useSeo({
    title: "Live Demo",
    description: "Preview a sample NEXORA website on desktop, mobile and full-screen.",
    path: "/demo"
  });
  return <>
      <PageHero crumbs={[{
      label: "Live Demo"
    }]} eyebrow="Live demo" title="Try a NEXORA build on any screen." lead="Toggle between desktop and mobile, or open full-screen. The sample restaurant site uses placeholder content to show how a build adapts." actions={<CtaLink to="/contact" track="demo_hero_build" size="lg" data-id="element-727" data-mp="xytnnwrjhu7w">Build My Website <ArrowRightIcon className="h-4 w-4" data-id="element-728" data-mp="12x4vy326rwo0" /></CtaLink>} data-id="element-726" data-mp="3elw6dwojh8xl" />
      <section className="shell section" data-id="element-729" data-mp="12vabeputu6kg">
        <DemoViewer data-id="element-730" data-mp="2de5n19bibx1c" />
      </section>
      <CtaBand source="demo" data-id="element-731" data-mp="2dd4dj9a53ilq" />
    </>;
}